export enum MAGAZINE_TYPE_BASE_URLS {
  COLUMN = '/cms/magazine/column',
  FEATURE = '/cms/magazine/feature',
  CATEGORY = '/cms/categories'
}

export const MAGAZINE_TYPES_MAX_ARTICLE_PER_TYPES = 8
export const MAGAZINE_TYPES_MAX_ARTICLE_PER_TYPE_ITEMS = 24
export const MAX_NUMBER_OF_DISPLAY_PAGES = 10

export enum MAGAZINE_TYPES {
  COLUMN = 'column',
  FEATURE = 'feature',
  CATEGORY = 'categories'
}

export const CMS_CATEGORY_URL_QUERY = {
  referred: 'magazine'
}
